"use client"

import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

export function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme()
  const isDark = (resolvedTheme ?? theme) === "dark"

  const toggleTheme = () => {
    if (isDark) {
      setTheme("light")
    } else {
      setTheme("dark")
    }
  }

  return (
    <button
      onClick={toggleTheme}
      className="app-icon-button"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={isDark}
      data-analytics-category="THEME_PREFERENCE"
      data-analytics-action="TOGGLE"
      data-analytics-name={isDark ? "THEME_SWITCH_TO_LIGHT" : "THEME_SWITCH_TO_DARK"}
    >
      {isDark ? <Sun className="h-5 w-5" aria-hidden="true" /> : <Moon className="h-5 w-5" aria-hidden="true" />}
    </button>
  )
}
